import { Component, Inject, Input } from '@angular/core';

import {OnInit} from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'rm-expiry-report-dialog',
  templateUrl: './expiry-report-dialog.component.html',
  styleUrls: ['./expiry-report-dialog.component.css']
})
export class ExpiryReportDialogComponent implements OnInit {
  productId: string;
  gcp: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {
    debugger;
    this.productId = this.data.productId;
    this.gcp = this.data.gcp;
  }

}